import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const rankingApi = createApi({
  reducerPath: "getRanking",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/ranking" }),
  endpoints: (builder) => ({
    getRanking: builder.query({
      query: ({ studentId, batchCode }) => ({
        url: `/student/${studentId}/batch/${batchCode}`,
        method: "GET",
      }),
      providesTags: ["Ranking"],
    }),
  }),
});

export const { useGetRankingQuery } = rankingApi;
